import { render, staticRenderFns } from "./AddSubPreview.vue?vue&type=template&id=d988d18a&lang=pug&"
import script from "./AddSubPreview.vue?vue&type=script&lang=js&"
export * from "./AddSubPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports